import dayjs from 'dayjs';

export const today = dayjs().format('YYYY-MM-DD');
